import { render, staticRenderFns } from "./redeemList.vue?vue&type=template&id=6f583253"
import script from "./redeemList.vue?vue&type=script&lang=js"
export * from "./redeemList.vue?vue&type=script&lang=js"
import style0 from "./redeemList.vue?vue&type=style&index=0&id=6f583253&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f583253')) {
      api.createRecord('6f583253', component.options)
    } else {
      api.reload('6f583253', component.options)
    }
    module.hot.accept("./redeemList.vue?vue&type=template&id=6f583253", function () {
      api.rerender('6f583253', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/scanCouponCode/redeemList.vue"
export default component.exports